module.exports = __webpack_public_path__ + "static/media/bird_sitting_01_page12.193d190c.png";